import { createSelector } from 'reselect';

import * as constants from './constants';
import { PasswordState } from './types/PasswordState';

export const getState = (state: any): PasswordState =>
  state[constants.STATE_ROOT_KEY];

export const getPasswordRequestStatus = createSelector([getState], state => ({
  success: state.rules,
  error: state.error,
}));

export const getPasswordWasSaved = createSelector(
  [getState],
  state => state.saved,
);

export const getResetToken = createSelector(
  [getState],
  state => state.resetToken,
);

export const getPasswordRules = createSelector(
  [getState],
  state => state.rules,
);

export const getIsLoadingResetPassword = createSelector(
  [getState],
  state => state.resetIsLoading,
);

export const getResetLinkWasSent = createSelector(
  [getState],
  state => state.resetLinkSent,
);

export const getResetLinkIsLoading = createSelector(
  [getState],
  state => state.resetLinkIsLoading,
);

export const getForgotPasswordMessage = createSelector(
  [getState],
  state => state.forgotPasswordMessage,
);

export const hasError = createSelector([getState], state => state.error);
